<template>
  <div class='indexbox'>
    <div class="searchbox">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="val.name" :name="val.id" v-for="val in tablist" :key="val.name">
        </el-tab-pane>
      </el-tabs>
      <div class="btnbox">
        <el-button type="primary" @click="show=true">{{$t('lg.邀请用户')}}</el-button>
      </div>
      <div class="tablebox">
        <div class="draggable" v-loading='loading'>
          <el-table :data="tableData" stripe border>
            <el-table-column prop="email" :label="$t('lg.邮箱')" min-width='200' align='left' show-overflow-tooltip />
            <el-table-column prop="create_time" :label="$t('lg.用户创建时间')" min-width='200' align='left' show-overflow-tooltip />
            <el-table-column prop="is_main" :label="$t('lg.是否管理员')" min-width='200' align='left' show-overflow-tooltip>
              <template slot-scope="scope">
                <p v-if="scope.row.is_main==1">{{$t('lg.是')}}</p>
                <p v-if="scope.row.is_main==0">{{$t('lg.否')}}</p>
              </template>
            </el-table-column>
            <el-table-column prop="status" :label="$t('lg.状态')" min-width='200' align='left' show-overflow-tooltip>
              <template slot-scope="scope">
                <p v-if="scope.row.status==0">{{$t('lg.待处理')}}</p>
                <p v-else>{{$t('lg.已启用')}}</p>
              </template>
            </el-table-column>
            <el-table-column prop="status" :label="$t('lg.操作')" min-width='200' align='left' show-overflow-tooltip>
              <template slot-scope="scope">
                <el-button v-hasPermi="['settings']" type="primary" size="small" @click="setdata(scope.row)">{{$t('lg.权限')}}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination @current-change='pagechage' background layout="total,prev, pager, next" v-show="total>0" :current-page.sync="page" :page-size="10" :total="total" />
      </div>
    </div>
    <el-dialog :title="$t('lg.邀请用户')" :visible.sync="show" width="30%">
      <el-form ref="form" :model="form" :rules="rules" class="formbox">
        <el-form-item prop="email">
          <span class="form_tit">{{$t('lg.邮箱')}}</span>
          <el-input v-model="form.email"></el-input>
        </el-form-item>
        <el-form-item class="btnbox">
          <el-button type="primary" @click.native.prevent="onSubmit" :loading='btn_loading'>{{$t('lg.保存')}}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  export default {
    computed: {
      ...mapGetters(['api_id']),
    },
    data() {
      return {
        ruleList: [],
        tablist: [
          { name: this.$t('lg.用户'), id: '1' }
          // {name:this.$t('lg.角色'),id:'2'}
        ],
        activeName: '1',
        loading: false,
        total: 0,
        page: 1,
        tableData: [],
        show: false,
        btn_loading: false,
        form: {
          email: '',
        },
        rules: {
          email: [
            { required: true, trigger: "blur", message: this.$t('lg.请输入') }
          ],
        },
      };
    },
    methods: {
      handleClick(tab) {
        sessionStorage.setItem("user_activeName", tab.name)
        this.activeName = tab.name
      },
      getlist() {
        this.loading = true
        this.$post({
          url: "/app/api_user/userList",
          data: {
            page: this.page,
            api_id: this.api_id
          },
          success: (res) => {
            this.tableData = res.data.data
            this.total = res.data.total
            setTimeout(() => {
              this.loading = false
            }, 200);
          },
          tip: () => {
            this.loading = false
          },
        })
      },
      pagechage(page) {
        this.page = page
        this.tableData = []
        this.getlist()
      },
      setdata(data) {
        this.$router.push(`rules?id=${data.id}`)
      },
      // 邀请用户
      onSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.btn_loading = true
            this.$post({
              url: "/app/member/sendInviteEmail",
              data: { ...this.form, api_id: this.api_id },
              success: (res) => {
                this.$message({
                  message: this.$t('lg.成功'),
                  type: 'success'
                });
                this.form = {
                  email: '',
                  api_id: '',
                }
                this.show = false
                setTimeout(() => {
                  this.btn_loading = false
                }, 1500);
              },
              tip: () => {
                setTimeout(() => {
                  this.btn_loading = false
                }, 1500);
              },
            })
          }
        });
      },
    },
    created() {
      this.getlist()
    },
  }
</script>
<style lang='scss' scoped>
  .indexbox {
    width: 100%;
    height: 100%;
    .searchbox {
      width: 100%;
      padding: 10px 20px 0px;
      background: #fff;
      border-bottom: 1px solid #babdcd;
    }
    .btnbox {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
    .tablebox {
      width: 100%;
      padding: 10px 10px 20px;
    }
    .formbox {
      /deep/.el-form-item {
        margin-bottom: 30px !important;
        .el-select,
        .el-date-editor {
          width: 100%;
        }
        .el-form-item__content {
          width: 100%;
          .el-button {
            width: 100%;
            height: 48px;
            background: $color;
            border-radius: 5px;
            border-color: $color;
          }
        }
      }
    }
  }
</style>